module.exports = __webpack_public_path__ + "img/Entia-Lineas-de-transmision-distribucion-electrica-5.2783627b.webp";